import styled from '@emotion/styled';
import { Text, Button } from '@blueprint/ui';
import { css } from '@emotion/react';
import { FiltersLabel } from '../../../search/FiltersModal/Filters.styles';

export const StyledDropdown = styled.select(
    ({ theme: { colors } }) => css`
        border: 0;
        color: ${colors['primary-brand']};
        font-weight: bold;
        font-size: 1rem;
        -webkit-appearance: none;
        -moz-appearance: none;
        text-indent: 1px;
        text-overflow: '';
        font-family: 'Lato', sans-serif;
        text-align-last: right;
        background-color: ${colors.white};
    `
);

type StyledButtonProps = {
    isDisabled?: boolean;
};

export const UpdateButton = styled(Button)<StyledButtonProps>((props) => {
    const {
        isDisabled = false,
        theme: { colors }
    } = props;
    return css`
        opacity: ${isDisabled ? 0.4 : 1};
        cursor: ${isDisabled ? 'default' : 'pointer'};
        box-shadow: 0px 0.3rem 0.7rem ${colors['neutral-3']};
    `;
});

export const StyledLabel = styled(Text)(css``);

export const Wrapper = styled.div(
    ({ theme: { spacing } }) => css`
        display: flex;
        justify-content: space-between;
        padding: ${spacing['16px']} 0;
    `
);

export const FilterWrapper = styled.div(
    ({ theme: { spacing } }) => css`
        margin: 0;
        width: 100%;
        padding-bottom: ${spacing['16px']};
    `
);

export const LocationFilterWrapper = styled(FilterWrapper)(
    ({ theme: { spacing } }) => {
        return css`
            margin-top: ${spacing['24px']};
            z-index: 4;
        `;
    }
);

export const PropertyTypeRadio = styled.div(
    () => css`
        width: 50%;
        z-index: 0;
    `
);

export const StyledFiltersModal = styled.div(
    ({ theme: { spacing } }) => css`
        padding: ${spacing['16px']};
    `
);

export const RadiusDropdownWrapper = styled.div(
    ({ theme: { spacing } }) => css`
        margin-top: ${spacing['24px']};
    `
);

export const SelectedPropertyTypeWrapper = styled.div(
    ({ theme: { spacing } }) => css`
        margin-bottom: ${spacing['24px']};
    `
);

export const PriceFrequencyWrapper = styled.div(
    ({ theme: { spacing } }) => css`
        width: 100%;
        margin-bottom: ${spacing['16px']};
    `
);

export const PropertyTypeFilterLabel = styled(FiltersLabel)(
    () => css`
        margin-top: 0;
    `
);
